module.exports = __webpack_public_path__ + "static/media/cog.a1cc4101.svg";